import { api } from '@shared/api/api';

type TimeTrackingGroup = App.Domain.TimeTracking.Data.TimeTrackingGroupData;

export const getTimeTrackingGroup = api.createShow<TimeTrackingGroup>('time-tracking-groups/:id');
